import { ProcessOperationType } from 'types/Process';
import { ProcessExcelConfig } from './types';

/** Config Excel y payload para DISMINUCION_CAPITAL_SIN_CDI */
// eslint-disable-next-line import/prefer-default-export
export const DISMINUCION_CAPITAL_SIN_CDI_CONFIG: ProcessExcelConfig = {
  operationType: ProcessOperationType.DISMINUCION_CAPITAL_SIN_CDI,
  promotionColIndex: 0,
  accountNameColIndex: 2,
  payloadColumns: {
    investmentAccountId: { colIndex: 1, type: 'string', label: 'Cuenta de inversión' },
    exercise: { colIndex: 4, type: 'string', label: 'Ejercicio' },
    amount: { colIndex: 9, type: 'number', label: 'Monto total de intereses' },
    withHoldingOnInterest: {
      colIndex: 10,
      type: 'number',
      label: 'Retención sobre intereses',
    },
    paymentDate: { colIndex: 11, type: 'date', label: 'Fecha' },
  },
};
